export async function PsicoterapiaDelete(psicoterapiaId) {
  const authToken = sessionStorage.getItem("token");
  try {
    const response = await fetch(
      `https://app.tavad.com/hce/wp-json/wp/v2/psicoterapia/${psicoterapiaId}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}
